import stickySummary from '../components/plan-summary/sticky'
import toastNotification from 'pug/toastNotification'
import { ADD_EXTENDED } from 'messages'
import store from 'utils/store/withMiddleware'

function handleToggleSupplement() {
  const state = store.getState()
  const id = +this.getAttribute('data-id')
  const addOns = state.addOns.filter(id => id !== state.supplementalId)
  if (this.checked) {
    addOns.push(id)
  }
  toastNotification(ADD_EXTENDED)
  store.update({ addOns })
  stickySummary()
}

export default handleToggleSupplement
